/**
 * Narwhalia backend
 * Swagger API docs for Narwhalia Backend application
 *
 * OpenAPI spec version: 0.9
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PriceDto } from './priceDto'
import { OwnerDto } from './ownerDto'
import { Gender } from './gender'
import { LooksDto } from './looksDto'
import { ColorsDto } from './colorsDto'
export { OwnerDto } from './ownerDto'
export { Gender } from './gender'

/** narwhal object. For sale if price present */
export interface NarwhalDto {
	/** The age to display */
	age: number;
	/** The actual level of the age */
	ageLevel: number;
	/** The actual user allowed to like the narwhal present only if true */
	canLike?: boolean;
	/** Name of the clan */
	clanName: string;
	colors: ColorsDto;
	/** true If narwhal is exclusive (alpha) present only if true */
	exclusive?: boolean;
	/** Fitness value */
	fitness: number;
	/** The level os fitness */
	fitnessLevel: number;
	/** Generation null = 1 */
	gen?: number;
	/** Ext ID of the narwhal */
	id: string;
	/** nr of likes */
	likes: number;
	/** true If there is a payment in progress, present only if true */
	lockBuy?: boolean;
	looks: LooksDto;
	/** Given name of the narwhal */
	name: string;
	/** absent if the system is the owner */
	owner?: OwnerDto;
	/** name of the unique image for female and alpha males absent for normal males */
	picture?: string;
	/** in glitter */
	price?: PriceDto;
	/** The productivity value */
	productivity: number;
	/** The level of productivity */
	productivityLevel: number;

// Locally calculated
	fitnessPercentage: string;

	productivityPercentage: string;

	/** male / female */
	gender: Gender;
}

export class NarwhalDto {
	static mixin<T extends NarwhalDto>(thiz: T): T {
		thiz.gender = null != thiz.picture && !thiz.exclusive ? Gender.Female : Gender.Male
		if(!thiz.owner) {
			thiz.owner = new OwnerDto()
		}
		return thiz;
	}
}